import CustomerAPI from 'api/customer.api';
import { updateLoadingState } from 'store/app.slice';
import {
  type IUpdateCustomerPayload,
  type ICreateCustomerPayload,
} from 'types/payloads/customer.payload.types';
import { BaseHandler } from './base.handler';
import { getAll, appendCustomer } from 'store/customer.slice';
import {
  type NotificationState,
  showNotification,
} from 'store/notification.slice';

export default class CustomerHandler extends BaseHandler {
  private readonly api: CustomerAPI;
  constructor() {
    super();

    this.api = new CustomerAPI();
  }

  // create user using api
  async createCustomer(payload: ICreateCustomerPayload): Promise<void> {
    try {
      const newCustomer = await this.api.createCustomer(payload);
      this.dispatch(appendCustomer(newCustomer));
      const notificationPayload: NotificationState = {
        isLoading: false,
        message: 'Customer created successfully!',
        show: true,
        type: 'success',
      };
      this.dispatch(showNotification(notificationPayload));
    } catch (error: any) {
      // show snackbar error
      const errorMsg =
        error?.response?.data?.message ??
        'Error while creating customer, pls try again';

      const notificationPayload: NotificationState = {
        isLoading: false,
        message: errorMsg,
        show: true,
        type: 'error',
      };
      console.log({ notificationPayload });

      this.dispatch(showNotification(notificationPayload));
      // throw error;
    }
  }

  // get customers using api
  async getAll(updateRedux: boolean = true) {
    if (updateRedux) this.dispatch(updateLoadingState(true));
    try {
      const { customers } = await this.api.getAll();
      if (updateRedux) this.dispatch(getAll(customers));
      return customers;
    } catch (_) {
      // show snackbar error
    } finally {
      if (updateRedux) this.dispatch(updateLoadingState(false));
    }
  }

  async updateCustomer(payload: IUpdateCustomerPayload) {
    this.dispatch(updateLoadingState(true));
    try {
      const customer = await this.api.updateCustomer(payload);
      this.dispatch(updateLoadingState(false));
    } catch (_) {
      this.dispatch(updateLoadingState(false));
    }
  }

  async updateCustomerTheme(payload: { theme: string; customerId: string }) {
    this.dispatch(updateLoadingState(true));
    try {
      const customer = await this.api.updateCustomerTheme(payload);
      this.dispatch(updateLoadingState(false));
    } catch (_) {
      this.dispatch(updateLoadingState(false));
    }
  }
}
